import { StandardEvents } from '@shopify/events';
import '@theme/variant-picker';
import '@theme/media-gallery';

const states = new Map();
const initialized = new WeakSet();
const clamp = value => Math.min(1000, Math.max(10, Math.round(Number(value) || 100)));
const sectionFor = control => control.closest('.shopify-section') || control.closest('dialog') || control.parentElement;

function sync(control, state, updateNumber = true) {
  if (updateNumber) control.querySelector('[data-hf-grams-number]').value = String(state.grams);
  control.querySelector('[data-hf-grams-range]').value = String(state.grams);
  control.querySelector('[data-hf-grams-property]').value = state.grams + ' grams';
  control.querySelector('[data-hf-form-property]').value = state.form;
  control.querySelectorAll('[data-hf-grams]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.hfGrams) === state.grams)));
  control.querySelectorAll('[data-hf-form]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.hfForm === state.form)));
  window.__hfCustomSelectedGrams = state.grams;
  window.__hfSelectedForm = state.form;
}

function initialize(control) {
  if (initialized.has(control)) return;
  initialized.add(control);
  const variants = JSON.parse(control.querySelector('[data-hf-variants]').textContent);
  const productId = control.dataset.productId;
  let state = states.get(productId);
  if (!state) {
    const variant = variants.find(item => item.form === control.dataset.selectedForm) || variants[0];
    state = { grams: 100, form: variant?.form || control.dataset.selectedForm, variantId: variant?.id };
    states.set(productId, state);
  }
  sync(control, state);
  control.dataset.ready = '';
  const number = control.querySelector('[data-hf-grams-number]');
  const range = control.querySelector('[data-hf-grams-range]');
  number.addEventListener('input', () => {
    // Let customers finish typing before normalizing an incomplete number.
    if (number.validity.valid && number.value !== '') {
      state.grams = clamp(number.value);
      sync(control, state, false);
    }
  });
  number.addEventListener('change', () => { state.grams = clamp(number.value); sync(control, state); });
  range.addEventListener('input', () => { state.grams = clamp(range.value); sync(control, state); });
  control.querySelectorAll('[data-hf-grams]').forEach(button => button.addEventListener('click', () => {
    state.grams = Number(button.dataset.hfGrams);
    sync(control, state);
  }));
  control.querySelectorAll('[data-hf-form]').forEach(button => button.addEventListener('click', () => {
    const variant = variants.find(item => item.form === button.dataset.hfForm);
    if (!variant) return;
    state.form = variant.form;
    state.variantId = variant.id;
    sync(control, state);
    const section = sectionFor(control);
    const radio = Array.from(section.querySelectorAll('variant-picker input[type="radio"]')).find(input => input.value === state.form);
    if (radio) {
      if (!radio.checked) radio.click();
    } else {
      const idInput = control.closest('form')?.querySelector('input[name="id"]');
      if (idInput) { idInput.value = String(variant.id); idInput.dispatchEvent(new Event('change', { bubbles: true })); }
    }

  }));
}

function boot() {
  document.querySelectorAll('[data-hf-herb-controls]').forEach(initialize);
}
document.addEventListener(StandardEvents.productSelect, event => {
  event.promise?.then(() => {
    boot();
    document.querySelectorAll('[data-hf-herb-controls]').forEach(control => {
      const state = states.get(control.dataset.productId);
      if (state) {
        sync(control, state);
        const idInput = control.closest('form')?.querySelector('input[name="id"]');
        if (idInput) idInput.value = String(state.variantId);
        if (document.querySelector('#MainContent[data-template^="product"]')?.contains(control)) {
          const url = new URL(location.href);
          url.searchParams.set('variant', state.variantId);
          history.replaceState({}, '', url);
        }
      }
    });
  }).catch(error => {
    if (error?.name !== 'AbortError') console.warn('[herb-controls] Variant update failed:', error);
  });
});
new MutationObserver(boot).observe(document.body, { childList: true, subtree: true });
boot();
